import Avatar from '../Avatar';
import styles from './styles.module.scss';
import icon from '../../../../assets/imgs/logo.png';
import AppIcons from '../../icons';
import React, { useContext, useEffect, useState } from 'react';
import { AdminContext } from '../../context/AdminContext';
import HiddenAudioPlayer from '../HiddenAudioPlayer';
import SHARED from '../../constants';
import SettingPart from '../SettingPart';
import CookieFunction from '../../functions/cookieFunction';
import SharedFunc from '../../functions/SharedFunc';
const Header = ({
  content,
  children,
  className = '',
  onClick,
  title = content?.appTitle,
  src = false,
  local = true,
  showBack = false,
  exitFunction,
  showExitButton,
  setShowFiles,
  showFiles,
  showChildren = true,
}) => {
  console.log('icon==', icon);
  const {
    showUsers,
    setShowUsers,
    activeUser,
    setActiveUser,
    activeAudio,
    setActiveAudio,
    direction,
    setUserChannelId,
    showAbsolute,
    setShowAbsolute,
    showSearch,
    setSeekValue,
    setPlaying,
    setActiveMessage,
    setActiveMessageAudio,
    setActiveMenuFile,
    setOpenSettingModal,
    activeMenuFile,
    isMobile,
  } = useContext(AdminContext);
  let token = CookieFunction('get', 'ochattToken');
  // const [showAbsolute, setShowAbsolute] = useState(false);
  useEffect(() => {}, [activeAudio]);
  useEffect(() => {
    if (window.innerWidth < 650) {
      setShowAbsolute(true);
    }
  }, []);
  // useEffect(() => {
  //   if (window.innerWidth < 600 && !showUsers) {
  //     setShowAbsolute(false);
  //   }
  // }, [showUsers]);

  console.log('show', showAbsolute);
  console.log('activeMenuFile', activeMenuFile);

  // useEffect(() => {
  //   // window.electron.ipcRenderer.once('notification', (event) => {
  //   //   // console.log('hhhhhhhhhhhhhhhhhhhhhh');
  //   //   alert('h');
  //   // });
  //   window.electron.ipcRenderer.once('push-registration', () => {
  //     firebase
  //       .messaging()
  //       .requestPermission()
  //       .then((token) => {
  //         console.log('token=====', token);
  //       })
  //       .catch((err) => {});
  //   });
  // }, []);
  const scrollToId = () => {
    const element = document.getElementById(activeAudio?.id);

    if (element) {
      document
        ?.getElementById(activeAudio?.id)
        ?.scrollIntoView({ block: 'end', behavior: 'smooth' });
    } else {
      // content?.settingModal?.menu?.filter(x=>x.id==4)
      setActiveMenuFile({
        tab: content?.settingModal?.menu?.filter((x) => x.id == 4),
        subMenu: 3,
      });
      setOpenSettingModal(true);
    }
    // var topOfElement = document.getElementById(activeAudio?.id).offsetTop - 50;
    // if (topOfElement) {
    //   window.scroll({ top: topOfElement, behavior: 'smooth' });
    // }
  };
  return (
    <div
      className={`${styles.container} ${`${
        !isMobile && 'headerBg'
      } `}${className}  ${isMobile && ` mainBg mobileView `}`}
      onClick={onClick}
    >
      {token != undefined && token && (
        <>
          <div
            className={`${
              activeAudio
                ? `${styles.player} ${
                    direction == 'rtl' ? styles.playerRtl : styles.playerLtr
                  } `
                : styles.hidePlayer
            } mainBg cursor-pointer`}
            onClick={scrollToId}
          >
            <p>{activeAudio?.file?.name}</p>
            <HiddenAudioPlayer
              id={`hiddenAudio`}
              src={
                activeAudio
                  ? `${SharedFunc(
                      activeAudio?.file?.serverId,
                      'socketServerMusic'
                    )}${activeAudio?.file?.name}`
                  : ''
              }
              // src={
              //   item?.id == activeMessage
              //     ? `${SHARED?.socketServerMusic}${item?.file?.name}`
              //     : ''
              // }
              // onClick={() => {
              //   // setActiveMessage(item?.id);
              // }}
              // setActiveMessage={setActiveMessage}
              // activeMessage={activeMessage}
              // control={true}
              // controls
            />
            <AppIcons.closeIcon
              width={15}
              height={17}
              fill={'#fff'}
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                setActiveMessage('');
                setActiveMessageAudio('');
                setSeekValue(0);
                setPlaying(false);
                setActiveAudio();
                setActiveMenuFile();
              }}
            />
          </div>

          <div
            className={`${showFiles ? styles.right50 : styles.right} flex-02 ${
              showAbsolute ? styles.showAbsolute : styles.hideAbsolute
            } ${
              direction == 'rtl' && children && activeUser ? 'br-0' : 'bl-0'
            } `}
          >
            {/* {showBack && (
          <AppIcons.ArrowLeftIconGray
            onClick={() => {
              setShowUsers(true);
              setActiveUser();
              setUserChannelId('');
              setShowAbsolute(true);
            }}
            className={`${styles.rotate180} cursor-pointer`}
            width={12}
            height={16}
          />
        )} */}
            <SettingPart
              content={content}
              exitFunction={exitFunction}
              showExitButton={showExitButton}
              setShowFiles={setShowFiles}
              showFiles={showFiles}
              setShowAbsolute={setShowAbsolute}
            />
            {/* <div className={styles.left}>{children}</div> */}
            {/* <Avatar
          src={src ? src : icon}
          local={local}
          extraClassName={styles.avatar}
        />
        <p className={styles.name}>{title}</p> */}
          </div>
          {showChildren && (
            <div
              className={`${styles.left}  ${
                !isMobile &&
                (direction == 'rtl' ? 'seperatorRight' : 'seperatorLeft')
              }
         
           `}
            >
              {children}
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default Header;

// ${
//   !showAbsolute ? styles.showAbsolute : styles.hideAbsolute
// }
